/**
 * (c) 2021, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Text,
} from "@microbit/ui";
import { FormattedMessage } from "react-intl";
import { HStack, VStack } from "styled-system/jsx";
import DialogHeading from "../common/DialogHeading";

interface WelcomeDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Der Dialog hinter "More" am unteren Rand der Seitenleiste.
 *
 * Vorerst ein Platzhalter. Vorher zeigte er das Einfuehrungsvideo des
 * micro:bit-Editors von YouTube, das zu dieser Oberflaeche nicht passt.
 */
const WelcomeDialog = ({ isOpen, onClose }: WelcomeDialogProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalCloseButton />
      <ModalBody>
        <VStack
          width="auto"
          ml="auto"
          mr="auto"
          p="5"
          pb="0"
          gap="5"
          alignItems="stretch"
        >
          <DialogHeading>
            <FormattedMessage id="welcome-placeholder-title" />
          </DialogHeading>
          <Text>
            <FormattedMessage id="welcome-placeholder-message" />
          </Text>
        </VStack>
      </ModalBody>
      <ModalFooter>
        <HStack gap="2.5">
          <Button size="lg" variant="primary" onPress={onClose}>
            <FormattedMessage id="close-action" />
          </Button>
        </HStack>
      </ModalFooter>
    </Modal>
  );
};

export default WelcomeDialog;
